<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"margin-top:100px;"' class="container" >
                <template #default>   <m-single-post-200 v-bind='{...{"contentLink":null,"flatCategoriesShape":false,"relatedPostCard":"mPostCard310"},...{}}' :style='""' class="" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                
                <template #p-3>   </template>
                </m-single-post-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSinglePost200 from '@moeinmdn/miw-alpha-components/src/package/Post/Single/SinglePost200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSinglePost200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
